/* eslint-disable */
import React, { useEffect } from 'react';
import SecondaryNav from '../../components/mweb/SecondaryNav/SecondaryNav';
import { Link } from 'react-router-dom';
import { queryStringToJSON } from 'hb-redux-store/util/miscellaneousServices';
import { anchorScroll } from '../../MiscellaneousServices';
import AnalyticsService from 'AnalyticsService';
import WhatsappHelp from '../../components/common/WhatsappHelp/WhatsappHelp';
import { HALALBOX_INDIA_CC_NUMBER } from '../../hb-redux-store/util/constantServices';
import { RUPEE_SYMBOL } from '../../components/web-feature/Home/constant';

const TnC = props => {
  const companyName = 'SDZ AgriTech Pvt. Ltd.';
  const address =
    'WeWork, 10th Floor, Tower 1, Seawoods, Navi Mumbai, Maharastra, India - 400706';
  const email = 'care@vegxl.in';
  const qs = queryStringToJSON(props.location.search);
  const { header = true } = qs;
  const { hash = '' } = props.location;

  useEffect(() => {
    // Clevertap Analytics
    const key = 'View Terms And Condition';
    const payload = {
      title: 'Terms And Condition',
    };
    AnalyticsService.clevertap.sendCleverTapEvent(key, payload);
    if (hash) anchorScroll(hash, 100, 45);
  }, []);

  return (
    <div className="tnc">
      {header && (
        <SecondaryNav
          source="accounts"
          showCart={false}
          showSearch={false}
          title="Terms and conditions"
          capitalize
        />
      )}
      <div className="tnc--header">TERMS OF SERVICE AGREEMENT</div>
      <p>
        PLEASE READ THIS TERMS OF SERVICE AGREEMENT CAREFULLY. BY USING THIS
        WEBSITE OR ORDERING PRODUCTS FROM THIS WEBSITE YOU AGREE TO BE BOUND BY
        ALL OF THE TERMS AND CONDITIONS OF THIS AGREEMENT.
      </p>
      <p>
        SDZ AGRITECH PRIVATE LIMITED is the sole owner of the property VEGXL.
        This Terms of Service Agreement (the "Agreement") governs your use of
        this website, www.vegxl.in (the "Website"), SDZ AgriTech Private Limited
        ("Business Name") offer of products for purchase on this Website, or
        your purchase of products available on this Website. This Agreement
        includes, and incorporates by this reference, the policies and
        guidelines referenced below. SDZ AgriTech Private Limited reserves the
        right to change or revise the terms and conditions of this Agreement at
        any time by posting any changes or a revised Agreement on this Website.
        SDZ AgriTech Private Limited will alert you that changes or revisions
        have been made by indicating on the top of this Agreement the date it
        was last revised. The changed or revised Agreement will be effective
        immediately after it is posted on this Website. Your use of the Website
        following the posting any such changes or of a revised Agreement will
        constitute your acceptance of any such changes or revisions. DZ Fresh
        Foods Private Limited encourages you to review this Agreement whenever
        you visit the Website to make sure that you understand the terms and
        conditions governing use of the Website. This Agreement does not alter
        in any way the terms or conditions of any other written agreement you
        may have with SDZ AgriTech Private Limited for other products or
        services. If you do not agree to this Agreement (including any
        referenced policies or guidelines), please immediately terminate your
        use of the Website. If you would like to print this Agreement, please
        click the print button on your browser toolbar.
      </p>
      <p>
        <ul>
          <li>
            <div className="tnc--title" id="products">
              PRODUCTS
            </div>
            <p>
              <span className="bold">Terms of Offer:</span> This Website offers
              for sale various products (the "Products"). By placing an order
              for Products through this Website, you agree to the terms set
              forth in this Agreement.{' '}
            </p>
            <p>
              <span className="bold">Customer Solicitation:</span> Unless you
              notify our SDZ AgriTech Private Limited sales reps, while they are
              calling you, of your desire to opt out from further direct company
              communications and solicitations, you are agreeing to continue to
              receive further emails and call solicitations DZ Fresh Foods
              Private Limited and its designated in house or third party call
              team(s).
            </p>
            <p>
              <span className="bold">Opt Out Procedure:</span> We provide 3 easy
              ways to opt out of from future solicitations.
              <br />
              1. You may use the opt out link found in any email solicitation
              that you may receive.
              <br />
              2. You may also choose to opt out, via sending your email address
              to: {email}
              <br />
              3. You may send a written remove request to {address};
            </p>
            <p>
              <span className="bold">Proprietary Rights: </span>SDZ AgriTech
              Private Limited has proprietary rights and trade secrets in the
              Products. You may not copy, reproduce, resell or redistribute any
              Product manufactured and/or distributed by SDZ AgriTech Private
              Limited. SDZ AgriTech Private Limited also has rights to all
              trademarks and trade dress and specific layouts of this webpage,
              including calls to action, text placement, images and other
              information.
            </p>
          </li>
          <li>
            <div className="tnc--title" id="website">
              WEBSITE
            </div>
            <p>
              <span className="bold">
                Content, Intellectual Property, Third Party Links:{' '}
              </span>
              In addition to making Products available, this Website also offers
              information and marketing materials. This Website also offers
              information, both directly and through indirect links to
              third-party websites, about nutritional and dietary supplements.
              SDZ AgriTech Private Limited does not always create the
              information offered on this Website; instead the information is
              often gathered from other sources. To the extent that DZ Fresh
              Foods Private Limited does create the content on this Website,
              such content is protected by intellectual property laws of the
              India, foreign nations, and international bodies. Unauthorized use
              of the material may violate copyright, trademark, and/or other
              laws. You acknowledge that your use of the content on this Website
              is for personal, noncommercial use. Any links to third-party
              websites are provided solely as a convenience to you. DZ Fresh
              Foods Private Limited does not endorse the contents on any such
              third-party websites. SDZ AgriTech Private Limited is not
              responsible for the content of or any damage that may result from
              your access to or reliance on these third-party websites. If you
              link to third-party websites, you do so at your own risk.{' '}
            </p>
            <p id="use-of-website">
              <span className="bold">Use of Website: </span>SDZ AgriTech Private
              Limited is not responsible for any damages resulting from use of
              this website by anyone. You will not use the Website for illegal
              purposes. You will (1) abide by all applicable local, state,
              national, and international laws and regulations in your use of
              the Website (including laws regarding intellectual property), (2)
              not interfere with or disrupt the use and enjoyment of the Website
              by other users, (3) not resell material on the Website, (4) not
              engage, directly or indirectly, in transmission of "spam", chain
              letters, junk mail or any other type of unsolicited communication,
              and (5) not defame, harass, abuse, or disrupt other users of the
              Website
            </p>
            <p>
              <span className="bold">Posting: </span>By posting, storing, or
              transmitting any content on the Website, you hereby grant DZ FRESH
              FOODS PRIVATE LIMITED a perpetual, worldwide, non-exclusive,
              royalty-free, assignable, right and license to use, copy, display,
              perform, create derivative works from, distribute, have
              distributed, transmit and assign such content in any form, in all
              media now known or hereinafter created, anywhere in the world. DZ
              FRESH FOODS PRIVATE LIMITED does not have the ability to control
              the nature of the user-generated content offered through the
              Website. You are solely responsible for your interactions with
              other users of the Website and any content you post. DZ FRESH
              FOODS PRIVATE LIMITED is not liable for any damage or harm
              resulting from any posts by or interactions between users. DZ
              FRESH FOODS PRIVATE LIMITED reserves the right, but has no
              obligation, to monitor interactions between and among users of the
              Website and to remove any content SDZ AgriTech Private Limited
              deems objectionable, in MuscleUP Nutrition 's sole discretion.{' '}
            </p>
            <p id="sign-up">
              <span className="bold">SignUp/SignIn: </span>By providing us your
              phone number or email id, you allow us to contact you over
              phone/SMS/Whatsapp/Email overriding your DND consent. In order to
              opt-out from our Whatsapp Updates, pls send "STOP" message to{' '}
              {HALALBOX_INDIA_CC_NUMBER} on whatsapp or call/email to our
              customer care team.
            </p>
          </li>
          <li>
            <div className="tnc--title" id="disclaimer">
              DISCLAIMER OF WARRANTIES
            </div>
            <p>
              YOUR USE OF THIS WEBSITE AND/OR PRODUCTS ARE AT YOUR SOLE RISK.
              THE WEBSITE AND PRODUCTS ARE OFFERED ON AN "AS IS" AND "AS
              AVAILABLE" BASIS. SDZ AGRITECH PRIVATE LIMITED EXPRESSLY DISCLAIMS
              ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING,
              BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS
              FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT WITH RESPECT TO THE
              PRODUCTS OR WEBSITE CONTENT, OR ANY RELIANCE UPON OR USE OF THE
              WEBSITE CONTENT OR PRODUCTS. ("PRODUCTS" INCLUDE TRIAL PRODUCTS.)
            </p>
            <p>
              WITHOUT LIMITING THE GENERALITY OF THE FOREGOING, SDZ AGRITECH
              PRIVATE LIMITED MAKES NO WARRANTY:
            </p>
            <p>
              NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU
              FROM THIS WEBSITE WILL CREATE ANY WARRANTY NOT EXPRESSLY STATED
              HEREIN.
            </p>
          </li>
          <li>
            <div className="tnc--title" id="liability">
              LIMITATION OF LIABILITY
            </div>
            <p>
              SDZ AGRITECH PRIVATE LIMITED ENTIRE LIABILITY, AND YOUR EXCLUSIVE
              REMEDY, IN LAW, IN EQUITY, OR OTHWERWISE, WITH RESPECT TO THE
              WEBSITE CONTENT AND PRODUCTS AND/OR FOR ANY BREACH OF THIS
              AGREEMENT IS SOLELY LIMITED TO THE AMOUNT YOU PAID, LESS SHIPPING
              AND HANDLING, FOR PRODUCTS PURCHASED VIA THE WEBSITE.
            </p>
            <p>
              SDZ AGRITECH PRIVATE LIMITED WILL NOT BE LIABLE FOR ANY DIRECT,
              INDIRECT, INCIDENTAL, SPECIAL OR CONSEQUENTIAL DAMAGES IN
              CONNECTION WITH THIS AGREEMENT OR THE PRODUCTS IN ANY MANNER,
              INCLUDING LIABILITIES RESULTING FROM (1) THE USE OR THE INABILITY
              TO USE THE WEBSITE CONTENT OR PRODUCTS; (2) THE COST OF PROCURING
              SUBSTITUTE PRODUCTS OR CONTENT; (3) ANY PRODUCTS PURCHASED OR
              OBTAINED OR TRANSACTIONS ENTERED INTO THROUGH THE WEBSITE; OR (4)
              ANY LOST PROFITS YOU ALLEGE.
            </p>
          </li>
          <li>
            <div className="tnc--title" id="indemnification">
              INDEMNIFICATION
            </div>
            <p>
              You will release, indemnify, defend and hold harmless DZ FRESH
              FOODS PRIVATE LIMITED, and any of its contractors, agents,
              employees, officers, directors, shareholders, affiliates and
              assigns from all liabilities, claims, damages, costs and expenses,
              including reasonable attorneys' fees and expenses, of third
              parties relating to or arising out of (1) this Agreement or the
              breach of your warranties, representations and obligations under
              this Agreement; (2) the Website content or your use of the Website
              content; (3) the Products or your use of the Products (including
              Trial Products); (4) any intellectual property or other
              proprietary right of any person or entity; (5) your violation of
              any provision of this Agreement; or (6) any information or data
              you supplied to SDZ AgriTech Private Limited. When DZ FRESH FOODS
              PRIVATE LIMITED is threatened with suit or sued by a third party,
              SDZ AgriTech Private Limited may seek written assurances from you
              concerning your promise to indemnify SDZ AGRITECH PRIVATE LIMITED;
              your failure to provide such assurances may be considered by SDZ
              AgriTech Private Limited to be a material breach of this
              Agreement. SDZ AgriTech Private Limited will have the right to
              participate in any defense by you of a third-party claim related
              to your use of any of the Website content or Products, with
              counsel of SDZ AgriTech Private Limited choice at its expense. SDZ
              AgriTech Private Limited will reasonably cooperate in any defense
              by you of a third-party claim at your request and expense. You
              will have sole responsibility to defend SDZ AgriTech Private
              Limited against any claim, but you must receive SDZ AgriTech
              Private Limited prior written consent regarding any related
              settlement. The terms of this provision will survive any
              termination or cancellation of this Agreement or your use of the
              Website or Products.
            </p>
          </li>
          <li>
            <div className="tnc--title" id="modifications">
              MODIFICATIONS TO THE SERVICE AND PRICES
            </div>
            <p>
              Prices for our products are subject to change without notice. We
              reserve the right at any time to modify or discontinue the Service
              (or any part or content thereof) without notice at any time. We
              shall not be liable to you or to any third-party for any
              modification, price change, suspension or discontinuance of the
              Service.
            </p>
          </li>
          <li>
            <div className="tnc--title" id="privacy">
              PRIVACY
            </div>
            <p>
              SDZ AgriTech Private Limited believes strongly in protecting user
              privacy. Please refer to SDZ AgriTech Private Limited privacy
              policy, incorporated by reference herein{' '}
              <Link to="/help/policy">link to privacy policy</Link>, that is
              posted on the Website.
            </p>
          </li>
          <li>
            <div className="tnc--title" id="agreement">
              AGREEMENT TO BE BOUND
            </div>
            <p>
              By using this Website or ordering Products, you acknowledge that
              you have read and agree to be bound by this Agreement and all
              terms and conditions on this Website.{' '}
            </p>
          </li>
          <li>
            <div className="tnc--title" id="general">
              GENERAL
            </div>
            <p>
              <span className="bold">Force Majeure: </span>SDZ AGRITECH PRIVATE
              LIMITED will not be deemed in default hereunder or held
              responsible for any cessation, interruption or delay in the
              performance of its obligations hereunder due to earthquake, flood,
              fire, storm, natural disaster, act of God, war, terrorism, armed
              conflict, labor strike, lockout, or boycott.
            </p>
            <p>
              <span className="bold">Cessation of Operation: </span>DZ FRESH
              FOODS PRIVATE LIMITED may at any time, in its sole discretion and
              without advance notice to you, cease operation of the Website and
              distribution of the Products.
            </p>
            <p>
              <span className="bold">Entire Agreement: </span>This Agreement
              comprises the entire agreement between you and SDZ AGRITECH
              PRIVATE LIMITED and supersedes any prior agreements pertaining to
              the subject matter contained herein.
            </p>
            <p>
              <span className="bold">Effect of Waiver: </span>The failure of DZ
              FRESH FOODS PRIVATE LIMITED to exercise or enforce any right or
              provision of this Agreement will not constitute a waiver of such
              right or provision. If any provision of this Agreement is found by
              a court of competent jurisdiction to be invalid, the parties
              nevertheless agree that the court should endeavor to give effect
              to the parties' intentions as reflected in the provision, and the
              other provisions of this Agreement remain in full force and
              effect.
            </p>
            <p>
              <span className="bold">Governing Law: </span>This Website
              originates from the Mumbai, Maharastra This Agreement will be
              governed by the laws of the State of Maharashtra without regard to
              its conflict of law principles to the contrary. Neither you nor DZ
              Fresh Foods Pvt Ltd will commence or prosecute any suit,
              proceeding or claim to enforce the provisions of this Agreement,
              to recover damages for breach of or default of this Agreement, or
              otherwise arising under or by reason of this Agreement, other than
              in courts located in State of Maharastra. By using this Website or
              ordering Products, you consent to the jurisdiction and venue of
              such courts in connection with any action, suit, proceeding or
              claim arising under or by reason of this Agreement. You hereby
              waive any right to trial by jury arising out of this Agreement and
              any related documents.
            </p>
            <p>
              <span className="bold">Waiver of Class Action Rights: </span>BY
              ENTERING INTO THIS AGREEMENT, YOU HEREBY IRREVOCABLY WAIVE ANY
              RIGHT YOU MAY HAVE TO JOIN CLAIMS WITH THOSE OF OTHER IN THE FORM
              OF A CLASS ACTION OR SIMILAR PROCEDURAL DEVICE. ANY CLAIMS ARISING
              OUT OF, RELATING TO, OR CONNECTION WITH THIS AGREEMENT MUST BE
              ASSERTED INDIVIDUALLY
            </p>
            <p>
              <span className="bold">Termination: </span>SDZ AGRITECH PRIVATE
              LIMITED reserves the right to terminate your access to the Website
              if it reasonably believes, in its sole discretion, that you have
              breached any of the terms and conditions of this Agreement.
              Following termination, you will not be permitted to use the
              Website and SDZ AgriTech Private Limited may, in its sole
              discretion and without advance notice to you, cancel any
              outstanding orders for Products. If your access to the Website is
              terminated, SDZ AgriTech Private Limited reserves the right to
              exercise whatever means it deems necessary to prevent unauthorized
              access of the Website. This Agreement will survive indefinitely
              unless and until SDZ AgriTech Private Limited chooses, in its sole
              discretion and without advance to you, to terminate it.
            </p>
            <p>
              <span className="bold">Domestic Use: </span>SDZ AGRITECH PRIVATE
              LIMITED makes no representation that the Website or Products are
              appropriate or available for use in locations outside India. Users
              who access the Website from outside India do so at their own risk
              and initiative and must bear all responsibility for compliance
              with any applicable local laws.
            </p>
            <p>
              <span className="bold">Assignment: </span>You may not assign your
              rights and obligations under this Agreement to anyone. [DZ FRESH
              FOODS PRIVATE LIMITED may assign its rights and obligations under
              this Agreement in its sole discretion and without advance notice
              to you.
            </p>
            <p>
              <span className="bold">Severability: </span>In the event that any
              provision of these Terms of Service is determined to be unlawful,
              void or unenforceable, such provision shall nonetheless be
              enforceable to the fullest extent permitted by applicable law, and
              the unenforceable portion shall be deemed to be severed from these
              Terms of Service, such determination shall not affect the validity
              and enforceability of any other remaining provisions.
            </p>
          </li>
          <li>
            <div className="tnc--title" id="scratch-n-win">
              Scratch And Win Coupons
            </div>
            <p>
              All the Scratch & Win coupons will be applicable from the next day
              that is from Saturday.
            </p>
            <p>No minimum cart is needed to apply scratch and win coupons.</p>
            <p>
              Coupons earned in Scratch & Win offer are valid for 6 six days i.e
              till next Thursday night at 11:59 pm.
            </p>
            <p>
              The offer in coupon code cannot be clubbed or exchanged with any
              other prevailing or existing offer.
            </p>
          </li>
          {/*<li>*/}
          {/*  <div className="tnc--title" id="2022-pe-2022">*/}
          {/*    2022 pe 2022*/}
          {/*  </div>*/}
          {/*  <p>*/}
          {/*    The offer period for '2022 pe 2022' is only for the 1st-7th*/}
          {/*    January 2022.*/}
          {/*  </p>*/}
          {/*  <p>*/}
          {/*    At one time, can redeem only 50 Halalbox points with every*/}
          {/*    purchase.*/}
          {/*  </p>*/}
          {/*  <p>No minimum order</p>*/}
          {/*  <p>Points validity - 1 year</p>*/}
          {/*  <p>Only valid on first recharge between 1st-7th January 2022</p>*/}
          {/*  <p>On every transaction, you can redeem only 50 HB points.</p>*/}
          {/*  <p>*/}
          {/*    On adding, Rs.2022 or more to your Halalbox Money, you are*/}
          {/*    eligible for 100% HB points credit value in your HB points*/}
          {/*    account.*/}
          {/*  </p>*/}
          {/*  <p>*/}
          {/*    On adding, Rs.2021 and below to your Halalbox Money, you are*/}
          {/*    eligible for 50% HB points credit value in your HB points account.*/}
          {/*  </p>*/}
          {/*  <p>*/}
          {/*    If you change your mind and wish to credit the money back to your*/}
          {/*    account, the points gained through Halalbox Money will be*/}
          {/*    auto-debited from your HB points.*/}
          {/*  </p>*/}
          {/*  <p>Halalbox reserves the rights to any changes to the offer.</p>*/}
          {/*</li>*/}
          <li>
            <div className="tnc--title" id="hb-select">
              VegXL Select Membership
            </div>
            <p>
              VegXL 1 Month plan trial period – The first 4 days from the date
              of plan activation is the trial period. During this period
              cancellation & refund will be granted only if the order is less
              than 4. The refund amount will be calculated on pro-rata basis and
              credited within 5 working days to your{' '}
              <span className="bold">VXL Wallet</span>.
            </p>
            <p>
              VegXL 3 Months plan trial period - The first 7 days from the date
              of plan activation is the trial period. During this period
              cancellation & refund will be granted only if the order is less
              than 7. The refund amount will be calculated on pro-rata basis and
              credited within 5 working days to your{' '}
              <span className="bold">VXL Wallet</span>.
            </p>
            <p>
              VegXL 6 Months plan trial period - The first 14 days from the date
              of plan activation is the trial period. During this period
              cancellation & refund will be granted only if the order is less
              than 14. The refund amount will be calculated on pro-rata basis
              and credited within 5 working days to your{' '}
              <span className="bold">VXL Wallet</span>.
            </p>
            <p>
              VegXL 1 Year plan trial period - The first 30 days from the date
              of plan activation is the trial period. During this period
              cancellation & refund will be granted only if the order is less
              than 30. The refund amount will be calculated on pro-rata basis
              and credited within 5 working days to your{' '}
              <span className="bold">VXL Wallet</span>.
            </p>
            <p>
              VegXL retains and reserves all right to alter any terms &
              conditions at any point.
            </p>
          </li>
          {/*<li>*/}
          {/*  <div className="tnc--title" id="2000-hb-wallet-recharge">*/}
          {/*    Recharging HBMoney with {RUPEE_SYMBOL}2000 Currency*/}
          {/*  </div>*/}
          {/*  <ul>*/}
          {/*    <li>*/}
          {/*      <div className="tnc--title">Introduction</div>*/}
          {/*      <p>*/}
          {/*        {' '}*/}
          {/*        The following terms and conditions govern the purchase and use*/}
          {/*        of HBMoney Points ("Points") using a {RUPEE_SYMBOL}2000 note*/}
          {/*        ("Currency"). By participating in this program, you*/}
          {/*        acknowledge and agree to comply with these terms and*/}
          {/*        conditions.*/}
          {/*      </p>*/}
          {/*    </li>*/}
          {/*    <li>*/}
          {/*      <div className="tnc--title">Point System</div>*/}
          {/*      <p>*/}
          {/*        {' '}*/}
          {/*        HBMoney Points are a gift point system that holds redeemable*/}
          {/*        value equivalent to the purchased amount. The Points are*/}
          {/*        stored in your HBMoney Virtual Wallet system and can be used*/}
          {/*        as digital coins within our platform. Please note that the*/}
          {/*        term "Wallet" is used for convenience to help users understand*/}
          {/*        the concept easily, but HBMoney is not a transactional wallet*/}
          {/*        and does not hold any money or fiat currency.*/}
          {/*      </p>*/}
          {/*    </li>*/}
          {/*    <li>*/}
          {/*      <div className="tnc--title">Redemption</div>*/}
          {/*      <p>*/}
          {/*        {' '}*/}
          {/*        HBMoney Points can only be redeemed on our official website or*/}
          {/*        app and are not valid for use on any third-party websites or*/}
          {/*        applications. The Points can be used for eligible purchases or*/}
          {/*        services available within the HBMoney platform, subject to*/}
          {/*        availability and applicable terms.*/}
          {/*      </p>*/}
          {/*    </li>*/}
          {/*    <li>*/}
          {/*      <div className="tnc--title">Non-Refundable</div>*/}
          {/*      <p>*/}
          {/*        {' '}*/}
          {/*        Once HBMoney Points are purchased using the Rs 2000 Currency,*/}
          {/*        they are non-refundable. Customers are advised to carefully*/}
          {/*        consider their purchase before proceeding, as no refunds or*/}
          {/*        returns will be granted after the transaction is completed.*/}
          {/*      </p>*/}
          {/*    </li>*/}
          {/*    <li>*/}
          {/*      <div className="tnc--title">Limitations and Restrictions</div>*/}
          {/*      <p>*/}
          {/*        a. HBMoney Points cannot be exchanged for cash or any other*/}
          {/*        form of currency.*/}
          {/*        <br />*/}
          {/*        b. The Points are non-transferable and cannot be gifted or*/}
          {/*        sold to any third party.*/}
          {/*        <br />*/}
          {/*        c. SDZ AgriTech Pvt Ltd reserves the right to modify,*/}
          {/*        suspend, or terminate the Point system, including any*/}
          {/*        associated benefits or features, at any time without prior*/}
          {/*        notice.*/}
          {/*        <br />*/}
          {/*        d. Any attempt to manipulate or abuse the Point system may*/}
          {/*        result in the termination of your account and forfeiture of*/}
          {/*        all accumulated Points.*/}
          {/*        <br />*/}
          {/*        e. HBMoney Points have no expiration date as long as the*/}
          {/*        HBMoney platform remains operational. However, in the event of*/}
          {/*        platform closure or discontinuation, any unused Points will*/}
          {/*        become void.*/}
          {/*      </p>*/}
          {/*    </li>*/}
          {/*    <li>*/}
          {/*      <div className="tnc--title">Intellectual Property</div>*/}
          {/*      <p>*/}
          {/*        {' '}*/}
          {/*        All intellectual property rights associated with HBMoney*/}
          {/*        Points, including but not limited to trademarks, logos, and*/}
          {/*        designs, are the property of HBMoney and its affiliates. You*/}
          {/*        are granted a limited, non-exclusive, non-transferable right*/}
          {/*        to use the Points solely for personal and non-commercial*/}
          {/*        purposes within the HBMoney platform.*/}
          {/*      </p>*/}
          {/*    </li>*/}
          {/*    <li>*/}
          {/*      <div className="tnc--title">Privacy</div>*/}
          {/*      <p>*/}
          {/*        {' '}*/}
          {/*        By participating in the HBMoney Points program, you agree to*/}
          {/*        the collection, storage, and processing of your personal*/}
          {/*        information in accordance with our Privacy Policy. We will*/}
          {/*        handle your data with utmost care and take necessary measures*/}
          {/*        to protect your privacy.*/}
          {/*      </p>*/}
          {/*    </li>*/}
          {/*    <p>*/}
          {/*      By proceeding with the purchase of HBMoney Points using the{' '}*/}
          {/*      {RUPEE_SYMBOL}2000 Currency, you acknowledge that you have read,*/}
          {/*      understood, and agreed to these terms and conditions*/}
          {/*    </p>*/}
          {/*  </ul>*/}
          {/*</li>*/}
        </ul>
      </p>
      <div>
        <div className="tnc--footer" id="contact-us">
          Reach us for any concern at:
        </div>
        <p>
          {companyName}
          <br />
          {address}
          <br />
          Email: {email}
        </p>
      </div>
      <WhatsappHelp />
    </div>
  );
};

export default TnC;
